import { useTranslation } from "react-i18next";
import MapWithFilters from "../Map/MapWithFilters";
import Modal from "./Modal";

const OrdersMapModal = ({ onExit, ...props }) => {
  const { t } = useTranslation("", { keyPrefix: "orders_live" });

  return (
    <Modal onExit={onExit} {...props}>
      <h3>{t("orderMapTitle")}</h3>
      <MapWithFilters onExit={onExit} />
    </Modal>
  );
};

export default OrdersMapModal;
